export enum LinkType {
  Link = 'Link',
}
